import { render, staticRenderFns } from "./EditFolder.vue?vue&type=template&id=0ac72b72&"
import script from "./EditFolder.vue?vue&type=script&lang=js&"
export * from "./EditFolder.vue?vue&type=script&lang=js&"
import style0 from "./EditFolder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports